export default {
    order_placed_from: 'omt.gui.orders.search.filters.label.placed-on-after',
    order_placed_to: 'omt.gui.orders.search.filters.label.placed-on-before',
    max_age_days: 'omt.gui.orders.search.filters.label.max-age-days',
    promised_delivery_date: 'omt.gui.orders.search.filters.label.promised-delivery-date',

    hold_status: 'omt.gui.orders.search.filters.label.block-status',
    order_identifier: 'omt.gui.orders.search.filters.label.order-no',
    fulfilment_method: 'omt.gui.orders.search.filters.label.fulfilment-method',
    dispatch_request_status: 'omt.gui.orders.search.filters.label.dispatch-request-status',
    dispatch_date: 'omt.gui.general.label.dispatch-requests.dispatch-date',
    dispatch_type: 'omt.gui.orders.search.filters.label.dispatch-type',
    dispatcher_type: 'omt.gui.orders.search.filters.label.dispatcher-type',
    dispatcher_identifier: 'omt.gui.orders.search.filters.label.dispatcher-identifier',

    responsible_location_identifier: 'omt.gui.orders.search.filters.label.responsible-store-identifier',

    dispatch_request_batch_type: 'omt.gui.orders.search.filters.label.dispatch-request-batch-type',
    dispatch_request_batch_status: 'omt.gui.orders.search.filters.label.dispatch-request-batch-status',
    dispatch_request_batch_identifier: 'omt.gui.orders.search.filters.label.dispatch-request-batch-identifier',

    sales_channel_identifier: 'omt.gui.orders.search.filters.label.sales-channel',
    sales_formula_identifier: 'omt.gui.orders.search.filters.label.sales-formula',

    refunds: 'omt.gui.orders.search.filters.label.with-refunds',

    customer_identifier: 'omt.gui.orders.search.filters.label.customer-number',
    carrier_method: 'omt.gui.orders.search.filters.label.carrier-method',
    payment_method: 'omt.gui.orders.search.filters.label.payment-method',
    has_comments: 'omt.gui.orders.search.filters.label.has-comments',
    is_paused: 'Is gepauzeerd', // FIXME: Nog niet via translation omdat dit in release/expert pas goed geregeld is, dus het nu op de oude manier toevoegen is onzinnig.

    product_identifiers: 'omt.gui.orders.search.filters.label.product-identifiers',

    address_type: 'omt.gui.orders.search.filters.label.address-type',
    address_name: 'omt.gui.orders.search.filters.label.address-name',
    address_city: 'omt.gui.orders.search.filters.label.city',
    address_zipcode: 'omt.gui.orders.search.filters.label.zipcode',
    address_email: 'omt.gui.orders.search.filters.label.email',
    address_country: 'omt.gui.orders.search.filters.label.country',

    has_order_responsible_location: 'omt.gui.orders.search.filters.label.has-order-responsible-location',
    has_assign_error: 'omt.gui.orders.search.filters.label.has-assign-error',
    validation_status: 'omt.gui.orders.search.filters.label.validation-status',

    // Not used yet
    // limit: 'Resultaten per pagina',
    count_drqs: 'omt.gui.general.label.dispatch-requests.count',
    
    customer_city: 'omt.gui.general.label.customer-info.city',
    customer_country: 'omt.gui.general.label.customer-info.country',
    customer_email: 'omt.gui.general.label.customer-info.email',
    customer_name: 'omt.gui.general.label.customer-info.name',
    customer_number: 'omt.gui.general.label.customer-info.identifier',

    dispatcher_responsible: 'omt.gui.orders.label.responsible-location',
    dispatcher: 'omt.gui.orders.label.dispatcher',
    gross_price: 'omt.gui.orders.label.price.gross',
    grand_total: 'omt.gui.orders.label.price.grand-total',
    placed_at: 'omt.gui.general.label.placed-at',
    refund_status: 'omt.gui.orders.label.refund-status',
}
